import React, { Component } from 'react';
import CSSModules from 'helpers/CSSModulesUtil';
import styles from './styles.scss';
import { compose } from 'recompose';
import {
  Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import { connect } from 'react-redux'
import { downloadFiles } from 'containers/Project/NvqualSection/actions'

const mapDispatchToProps = (dispatch) => {
    return {
        onDownloadFile: (files, name) => dispatch(downloadFiles(files, name, true))
    }
}


class ErrorTable extends Component {

    errorHandleFunc = (errorType, info) => {
        const { errorSpecificRenderFunc } = this.props
        if (errorType == 'global_error_not_zero'){
            return <code>Error Code: {info.errorCode}</code>
        } else {
            return errorSpecificRenderFunc(errorType, info)
        }
    }

 render(){

  const { errors, onDownloadFile } = this.props

  return (
      <React.Fragment>
          {errors.length == 500 && <div className={styles.errorsLengthMsg}>Note: too many errors detected. Only the first 500 errors are shown.</div>}
        <Table selectable={false}>
        <TableHead key={`head`}>
        <TableCell key={`errorType`}>Error Type</TableCell>
        <TableCell key={`classification`}>Classification</TableCell>
        <TableCell key={`info`}>Error-Specific Information</TableCell>
        <TableCell key={`fileName`}>File</TableCell>
        <TableCell key={`fileLine`}>Line #</TableCell>
        </TableHead>
        {
            errors.map((x, idx) => { 
                const errorClass = x.classification == 'error' ? styles.red : styles.yellow
                return (
            <TableRow key={`${x.errorType}${idx}`}>
                <TableCell>{x.errorType}</TableCell>
                <TableCell><code className={errorClass}>{x.classification}</code></TableCell>
                <TableCell>{this.errorHandleFunc(x.errorType, x.info)}</TableCell>
                <TableCell><div className={styles.link} onClick={onDownloadFile.bind(this, [x.file.id], x.file.name)}>{x.file.name}</div></TableCell>
                <TableCell>{x.fileLine}</TableCell>
            </TableRow>)}) 
        }
    </Table>
  </React.Fragment>
  )
 }
}
const withConnect = connect(null, mapDispatchToProps)
const withStyles = CSSModules(styles);
const enhance = compose(withConnect, withStyles);
export default enhance(ErrorTable);
